import type { AxiosInstance } from 'axios';
import type {
  AdminDbReadRequest,
  AdminDbWriteRequest,
  AdminDbReadResponse,
  AdminDbWriteResponse,
} from '@/types';

export const readDatabase = async (
  api: AxiosInstance,
  sql: string,
): Promise<AdminDbReadResponse> => {
  const resp = await api.post<AdminDbReadResponse>('/accqsure/admin/db/read', {
    sql,
  } as AdminDbReadRequest);
  return resp.data;
};

export const writeDatabase = async (
  api: AxiosInstance,
  sql: string,
): Promise<AdminDbWriteResponse> => {
  const resp = await api.post<AdminDbWriteResponse>(
    '/accqsure/admin/db/write',
    {
      sql,
    } as AdminDbWriteRequest,
  );
  return resp.data;
};
